import { render, staticRenderFns } from "./SetupOrganization.vue?vue&type=template&id=31094d32&scoped=true&"
import script from "./SetupOrganization.vue?vue&type=script&lang=js&"
export * from "./SetupOrganization.vue?vue&type=script&lang=js&"
import style0 from "./SetupOrganization.vue?vue&type=style&index=0&id=31094d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31094d32",
  null
  
)

export default component.exports